import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'

import { Nullable } from '@shared/models/types/primary'

export function updateObjectInArray<T>(
  array: Nullable<T[]>,
  data: T,
  filterKey: keyof T
): T[] {
  if (isEmpty(data)) {
    return array ?? []
  }
  const newArray = cloneDeep(array) ?? []
  const index = newArray.findIndex(
    (item) => item[filterKey] === data[filterKey]
  )
  if (index !== -1) {
    newArray[index] = data
  } else {
    newArray.push(data)
  }
  return newArray
}
